import React, { Component, ReactNode } from 'react';
import Router, { publicPaths } from './features/router/Router';
import { NotificationManager } from './features/notification-manager/NotificationManager';
import { store } from './app/store';
import { UserHelper } from './helpers/UserHelper';
import Spinner from 'react-bootstrap/Spinner';
import { AuthHelper, NotAuthorizedError } from './helpers/AuthHelper';
import { updateUnreadState } from './api';
import { ActivityHelper } from './helpers/ActivityHelper';
import { ERouterPath } from './features/router/ERouterPath';

interface AppState {
  loaded: boolean;
}

class App extends Component<any, AppState> {
  state: AppState = {
    loaded: false,
  };

  componentDidMount(): void {
    ActivityHelper.init();
    this.load()
      .catch(error => {
        const authIsInvalid =
          error instanceof NotAuthorizedError ||
          ['MissingMfaForCognitoTokenError', 'InvalidCognitoTokenError', 'MissingAcceptedPoliciesForCognitoTokenError'].includes(error.key);

        if (!authIsInvalid) {
          console.error('Error occurred during load', error);
          return;
        }

        const atPublicPath = publicPaths.some(path => window.location.pathname.startsWith(path));
        if (!atPublicPath) {
          console.warn('Token was invalid, logout user', error);
          window.location.replace(`${window.location.origin}${ERouterPath.logout}`);
        }
      })
      .finally(() => this.setState({ loaded: true }));
  }

  private async load(): Promise<void> {
    await this.loadUser();
    await updateUnreadState().catch(err => console.error('Failed first unread state init', err));
  }

  private async loadUser(): Promise<void> {
    const { user } = store.getState().session;
    const token = await AuthHelper.getAccessJwtToken();
    if (token && !user) {
      await UserHelper.fetchAndStoreUser();
    }
  }

  render(): ReactNode {
    const { loaded } = this.state;
    if (loaded) {
      return <>
        <Router />
        <NotificationManager />
      </>;
    } else {
      return <Spinner animation="border" role="status">
        <span className="sr-only">Laden...</span>
      </Spinner>;
    }
  }
}

export default App;
